{
  "version": 1,
  "asset_id": "a904d3dc-a176-483f-bb50-11b3a5d4e9d5",
  "project_id": "1e4fe108-4756-4697-836a-97816893411c",
  "url": "/__l5e/assets-v1/a904d3dc-a176-483f-bb50-11b3a5d4e9d5/trailer-poster-clean.jpg",
  "r2_key": "a/v1/1e4fe108-4756-4697-836a-97816893411c/a904d3dc-a176-483f-bb50-11b3a5d4e9d5/trailer-poster-clean.jpg",
  "original_filename": "trailer-poster-clean.jpg",
  "size": 157879,
  "content_type": "image/jpeg",
  "created_at": "2026-09-05T16:42:50Z"
}
